import { App } from "./app";

export class Entity{
    constructor(){
        this.root = new THREE.Group();
        App.instance.scene.add(this.root);
        App.instance.entities.push(this);
    }

    update(){

    }

    destroy(){
        MAD.App.instance.destroyEntity(this);
    }
}